import React, { useEffect } from "react";
import $ from "jquery";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

function WelSnapVideo() {
  useEffect(() => {
    Fancybox.bind('[data-fancybox="single"]', {
      groupAttr: false,
    });

    return () => {
      Fancybox.destroy();
    };
  }, []);
  return (
    <>
      <section className="wel-snap-vid" id="">
        <div className="row ">
          <div className="container">
            <div className="welcome">
              <div className="wel-snap wow fadeInLeft">
                <div className="title dsk wow zoomIn">
                  <h2>
                    Welcome to <span className="red secnd">Snapshot Video</span>
                  </h2>
                </div>
                <div className="wl-sec">
                  <p className="wl-para">
                    Lorem ipsum dolor sit amet, consectetuer adipiscing elit,
                    sed diam nonummy nibh euismod tincidunt ut laoreet dolore
                    magna.
                  </p>
                  <ul className="wel-check">
                    <li className="check-list">
                      Lorem ipsum dolor sit amet, consectetuer adipiscing elit
                    </li>
                    <li className="check-list">
                      Sed diam nonummy nibh euismod tincidunt
                    </li>
                    <li className="check-list">
                      Laoreet dolore magna aliquam erat volutpat.{" "}
                    </li>
                    <li className="check-list">
                      Ut wisi enim ad minim veniam, quis nostrud exerci tation
                    </li>
                    <li className="check-list">
                      Aliquip ex ea commodo consequat.{" "}
                    </li>
                    <li className="check-list">
                      Duis autem vel eum iriure dolor in hendrerit
                    </li>
                    <li className="check-list">
                      vulputate velit esse molestie consequat
                    </li>
                  </ul>
                </div>
              </div>
              <div className="wel-vid wow fadeInRight">
                <div className="title mb wow zoomIn">
                  <h2>
                    Welcome to <span className="red secnd">Snapshot Video</span>
                  </h2>
                </div>
                <div
                  className="banner-image wow fadeInRight"
                  style={{
                    visibility: "visible",
                    animationName: "fadeInRight",
                  }}
                >
                  <a
                    data-fancybox="single"
                    href="images/video-1.mp4"
                    className="popup popup-btn"
                  ></a>
                  <img
                    src={require("../../assets/images/Welcome-to-Snapshot.jpg")}
                    alt="Welcome-to-Snapshot right image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default WelSnapVideo;
